module.exports = __webpack_public_path__ + "img/confusedLREXDino.198f0a89.png";